'use client';

import type { ComponentProps, MouseEvent } from 'react';
import { trackEvent } from '@/lib/analytics/counterscale';

type Props = ComponentProps<'a'> & { event: string };

export function TrackedAnchor({ event, onClick, ...rest }: Props) {
  return (
    <a
      {...rest}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        trackEvent(event);
        onClick?.(e);
      }}
    />
  );
}
